<span class="relative">
  @if (isChanged) {
    <span class="padding-left" (mouseover)="showInitialValue = !showInitialValue" (mouseout)="showInitialValue = !showInitialValue"><svg-icon aria-hidden="true" icon="icon-delta" class="tiny light-blue"></svg-icon></span>
    }<span [ngClass]="showInitialValue ? 'show-full-text' : 'hide-full-text'">{{initialValue}}</span>
  </span>